import AssetWithContentBlock from '@blocks/assetWithContent/AssetWithContentBlock.svelte';
import AssetWithDescriptionBlock from '@blocks/assetWithDescription/AssetWithDescriptionBlock.svelte';
import DescriptionBlock from '@blocks/description/DescriptionBlock.svelte';
import DescriptionListBlock from '@blocks/descriptionList/DescriptionListBlock.svelte';
import CaseListBlock from '@blocks/caseList/CaseListBlock.svelte';
import BlogListBlock from '@blocks/blogList/BlogListBlock.svelte';
import LinkListBlock from '@blocks/linkList/LinkListBlock.svelte';
import ServiceListBlock from '@blocks/serviceList/ServiceListBlock.svelte';
import EmployeeListBlock from '@blocks/employeeList/EmployeeListBlock.svelte';
import AccordionBlock from '@blocks/accordion/AccordionBlock.svelte';
import AssetBlock from '@blocks/asset/AssetBlock.svelte';
import HeroBlock from '@blocks/hero/HeroBlock.svelte';
import TextBlock from '@blocks/text/TextBlock.svelte';
import FeaturedServiceBlock from '@blocks/featuredService/FeaturedServiceBlock.svelte';
import QuoteBlock from '@blocks/quote/QuoteBlock.svelte';
import BreakerBlock from '@blocks/breaker/BreakerBlock.svelte';
import CarouselBlock from '@blocks/carousel/CarouselBlock.svelte';
import StatisticBlock from '@blocks/statistic/StatisticBlock.svelte';
import EmployeeWithDescriptionBlock from '@blocks/employeeWithDescription/EmployeeWithDescriptionBlock.svelte';
import TextSimpleBigBlock from '@blocks/textSimpleBig/TextSimpleBigBlock.svelte';
import DoubleContentBlock from './doubleContent/DoubleContentBlock.svelte';

export const ID_TO_BLOCK = new Map([
	['asset_with_content', AssetWithContentBlock],
	['asset_with_description_list', AssetWithDescriptionBlock],
	['double_content', DoubleContentBlock],
	['asset', AssetBlock],
	['featured_service', FeaturedServiceBlock],
	['accordion', AccordionBlock],
	['description', DescriptionBlock],
	['description_list', DescriptionListBlock],
	['hero', HeroBlock],
	['service_list', ServiceListBlock],
	['case_list', CaseListBlock],
	['blog_list', BlogListBlock],
	['link_list', LinkListBlock],
	['employee_list', EmployeeListBlock],
	['text', TextBlock],
	['breaker', BreakerBlock],
	['carousel', CarouselBlock],
	['statistic', StatisticBlock],
	['quote', QuoteBlock],
	['employee_with_description', EmployeeWithDescriptionBlock],
	['big_simple_text', TextSimpleBigBlock]
]);
